document.addEventListener('DOMContentLoaded', () => {
  const popupElement = document.querySelector('[data-modal^="catch-widget"]') ?? null;

  if (!popupElement) {
    return
  }

  const popupElementData = popupElement.dataset.delay ?? null;
  const delay = parseFloat(popupElementData) ?? null;

  function openPopup() {
    popupElement.popup.open();
  }

  setTimeout(function() {
    if ('popup' in popupElement) {
      openPopup();
    } else {
      window.addEventListener('popupLoaded', function() {
        openPopup();
      });
    }
  }, delay);
})
